import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';

/**
 * Barra visible en la parte superior de la web cuando el usuario tiene el modo admin activo.
 * Permite salir del modo admin con un clic (sin tener que escribir ?admin=off en la URL).
 */
const AdminBanner = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const check = () => {
      try {
        setIsAdmin(localStorage.getItem('jrf-admin') === 'true');
      } catch (e) {
        setIsAdmin(false);
      }
    };
    check();
    // Re-check when window regains focus (useful after admin toggle in another tab)
    window.addEventListener('focus', check);
    return () => window.removeEventListener('focus', check);
  }, []);

  const exitAdmin = () => {
    try {
      localStorage.removeItem('jrf-admin');
      localStorage.removeItem('jrf-admin-token');
    } catch (e) { /* ignore */ }
    setIsAdmin(false);
    // Reload to hide admin controls immediately across all components
    window.location.reload();
  };

  if (!isAdmin) return null;

  return (
    <div
      className="bg-yellow-400 text-black py-2 px-4 flex items-center justify-center gap-3 text-[11px] font-bold uppercase tracking-[0.2em] relative z-40"
      data-testid="admin-banner"
    >
      <Shield className="w-3.5 h-3.5" strokeWidth={2} />
      <span>Modo Admin Activo — Solo tú ves los botones editar/eliminar</span>
      <button
        onClick={exitAdmin}
        className="ml-2 border border-black hover:bg-black hover:text-yellow-400 px-3 py-1 text-[10px] font-bold uppercase tracking-widest transition-colors flex items-center gap-1"
        data-testid="admin-banner-exit"
        aria-label="Salir del modo admin"
      >
        <X className="w-3 h-3" strokeWidth={2} />
        Salir
      </button>
    </div>
  );
};

export default AdminBanner;
